import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EonUiComponentsAngularModule } from '@eon-ui/eon-ui-components-angular';
import { AuthenticationService } from '../../service/authentication.service';
import { LOCAL_STORAGE_URL_BEFORE_REDIRECT } from '../../config/oauth2/route-can-activate';

@Component({
    selector: 'app-login-redirect-view',
    standalone: true,
    imports: [
        EonUiComponentsAngularModule,
    ],
    templateUrl: './login-redirect-view.component.html',
    styleUrl: './login-redirect-view.component.scss',
})
export class LoginRedirectViewComponent {
    constructor(private authenticationService: AuthenticationService, private router: Router) {
        this.authenticationService.tryLoginFromRedirect().then((v) => {
            const url = localStorage.getItem(LOCAL_STORAGE_URL_BEFORE_REDIRECT);

            this.router.navigateByUrl(url === null ? '/' : url)
        });
    }
}
